import { render, staticRenderFns } from "./NotePill.vue?vue&type=template&id=b3442784&"
import script from "./NotePill.vue?vue&type=script&lang=js&"
export * from "./NotePill.vue?vue&type=script&lang=js&"
import style0 from "./NotePill.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports